import { render, staticRenderFns } from "./onBcms.vue?vue&type=template&id=8e61cb78"
import script from "./onBcms.vue?vue&type=script&lang=js"
export * from "./onBcms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports